import { render, staticRenderFns } from "./box.vue?vue&type=template&id=e1523530&scoped=true&"
import script from "./box.vue?vue&type=script&lang=js&"
export * from "./box.vue?vue&type=script&lang=js&"
import style0 from "./box.vue?vue&type=style&index=0&id=e1523530&prod&lang=scss&"
import style1 from "./box.vue?vue&type=style&index=1&id=e1523530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1523530",
  null
  
)

export default component.exports